import { navigate } from 'gatsby';
import React from 'react';
import { useSelector } from 'react-redux';
import { makeStyles, BottomNavigation, BottomNavigationAction } from '@material-ui/core';
import { useLocation } from '@reach/router';

import pages from './pages';
import { getMe } from 'src/features/users/state/selectors';

const useStyles = makeStyles(theme => ({
  root: {
    position: 'fixed',
    bottom: 0,
    width: '100%',
    height: 70,
    boxShadow: '0px 0px 30px rgba(0, 0, 0, 0.12)',
    backgroundColor: theme.palette.background.default,
    zIndex: 100,
  },
  bottomNavigationAction: {
    padding: theme.spacing(2, 0),
    minWidth: 'unset',
  },
  selected: {
    borderTop: '4px solid',
    borderColor: theme.palette.primary.main,
  },
}));

export default function MobileBottomNavigation() {
  const classes = useStyles();

  const userData = useSelector(getMe);
  const { pathname } = useLocation();

  const handleChange = (event, newValue) => {
    navigate(`/me${newValue}`);
  };

  return (
    <BottomNavigation value={pathname.split('/me')[1]} onChange={handleChange} className={classes.root}>
      {
        pages.map((page) => (
          ((page.name === 'Help and Support' && userData?.customer?.is_subaccount === false)
            || (page.name !== 'Help and Support' && (!page.allowedFor || (page.allowedFor && checkRole(page.allowedFor)))))
          && (
            <BottomNavigationAction
              key = { page.link || page.name }
              value = { page.link || (page.subPages && page.subPages.length > 0 && page.subPages[0]?.link) }
              icon = { page.icon }
              showLabel = { false}
              classes = {{ root: classes.bottomNavigationAction, selected: classes.selected }}
            />
          )
        ))
      }
    </BottomNavigation>
  );
}
